import { useEffect, useRef, useState } from "react";
import { AlertCircle, Clock, Search, User } from "react-feather";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { getBulkDropdownData } from "../../api/keyvalue";
import {
  addShift,
  getShiftActionById,
  getShiftById,
  getShiftUserById,
  searchShiftActionData,
  searchShiftData,
  searchShiftUserData,
  updateShift,
} from "../../api/shiftApi";
import { statusByContext } from "../../api/statusApi";
import { getBehalfOf } from "../../api/systemUserApi";
import Grid from "../../components/Grid";
import LoadingSpinner from "../../components/LoadingSpinner";
import Tab from "../../components/Tab";
import UIMessage from "../../components/UIMessage";
import Button from "../../components/input/Button";
import Dropdown from "../../components/input/Dropdown";
import Input from "../../components/input/Input";
import SearchDropdown from "../../components/input/SearchDropdown";
import SideDrawer from "../../components/input/SideDrawer";
import ShiftActionForm from "../../components/master/callCenter/ShiftActionForm";
import ShiftMasterForm from "../../components/master/callCenter/ShiftMasterForm";
import ShiftUsersForm from "../../components/master/callCenter/ShiftUsersForm";
import {
  ActiveCellStyle,
  StatusCellStyle,
} from "../../components/renderer/StyleRenderer";
import { shiftDetailsValidation } from "../../components/validations/ShiftCreation";
import { FORMS, MODULES, STATUS_GROUPS } from "../../const";
import useFirstAndLastAuthorizedTab from "../../hooks/useFirstAndLastAuthorizedTab";
import { errorActions } from "../../store/error-slice";
import Modal from "../../components/Modal";

const ShiftMaster = () => {
  const { firstViableTab, lastViableTab } = useFirstAndLastAuthorizedTab({
    module: MODULES.Master,
    section: FORMS.CALL_CENTER_SHIFT,
  });

  const errorState = useSelector((state) => state.error.shiftDetailsErrors);
  const dispatch = useDispatch();
  const [tab, setTab] = useState(1);
  const [drawerTab, setDrawerTab] = useState(1);
  // const { next, prev } = useNextAndPreviousAuthority({
  //     sectionKey: "blacklist",
  //     minTab: 1,
  //     maxTab: 2,
  //     module: MODULES.Master,
  //     section: FORMS.CALL_CENTER_SHIFT,
  //     currentTab: drawerTab,
  //     authenticated: true,
  // });
  const user = useSelector((state) => state.user);
  // edit data
  const [editShift, setEditShift] = useState({});
  const [editShiftUser, setEditShiftUser] = useState({});
  const [editShiftAction, setEditShiftAction] = useState({});

  const [isLoading, setIsLoading] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [searchFetchLoading, setSearchFetchLoading] = useState(false);

  const [submitted, setSubmitted] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [isSearchLoading, setIsSearchLoading] = useState(false);
  const [searchSubmitLoading, setSearchSubmitLoading] = useState(false);
  const [searchResShift, setSearchResShift] = useState(false);
  const [searchResUsers, setSearchResUsers] = useState(false);
  const [searchResAction, setSearchResAction] = useState(false);

  const deleteWarningRef = useRef();
  const [showDeleteWarning, setShowDeleteWarning] = useState(false);
  const [pendingSubmitEvent, setPendingSubmitEvent] = useState(null);

  //tab ref
  const userRef = useRef();
  const actionRef = useRef();
  const shiRef = useRef();

  // search ref
  const codeRef = useRef(null);
  const nameRef = useRef(null);
  const fromDateRef = useRef(null);
  const toDateRef = useRef(null);

  //search state
  const [status, setStatus] = useState(null);
  const [active, setActive] = useState(null);
  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);
  const [userSch, setUserSch] = useState(null);
  const [actionSch, setActionSch] = useState(null);

  const [searchFieldReset, setSearchFieldReset] = useState(false);

  // dropdown
  const [activeOptions, setActiveOptions] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);
  const [actionStatusOptions, setActionStatusOptions] = useState([]);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      setIsSearchLoading(true);

      //new

      const { active, status } = await getBulkDropdownData([
        { key: "active" },
        { key: "status" },
      ]);

      setActiveOptions(active);
      setStatusOptions(status);

      const actionStatusData = await statusByContext(STATUS_GROUPS.ALL);
      setActionStatusOptions(actionStatusData);

      setIsLoading(false);
      setIsSearchLoading(false);
    })();
  }, []);
  const handleDrawerOpen = () => {
    dispatch(errorActions.clearShiftDetailsError());
    setEditMode(false);
    setEditShift(null);
    setIsDrawerOpen(true);
  };

  const handleReset = (e) => {
    e.preventDefault();
    if (tab === 1) {
      setSearchClicked(false);
      setResetVisible(false);
    }
  };
  const handleSearchSubmit = async (e) => {
    e.preventDefault();
    setActiveAccordion1(false);
    setResetVisible(true);
    setSearchSubmitLoading(true);
    let response;
    if (tab === 1) {
      setSearchClicked(true);
      setSearchUserClicked(false);
      setSearchActionClicked(false);
      response = await searchShiftData({
        code: codeRef.current.value,
        name: nameRef.current.value,
        from: fromDateRef.current.value,
        to: toDateRef.current.value,
        status: status,
        active: active,
      });
      setSearchResShift(response);
      setSearchResUsers(null);
      setSearchResAction(null);
    } else if (tab === 2) {
      setSearchClicked(false);
      setSearchUserClicked(true);
      setSearchActionClicked(false);
      response = await searchShiftUserData({
        code: codeRef.current.value,
        name: userSch,
        from: fromDateRef.current.value,
        to: toDateRef.current.value,
        status: status,
        active: active,
      });
      setSearchResShift(null);
      setSearchResUsers(response);
      setSearchResAction(null);
    } else {
      setSearchClicked(false);
      setSearchUserClicked(false);
      setSearchActionClicked(true);
      response = await searchShiftActionData({
        code: codeRef.current.value,
        name: actionSch,
        from: fromDateRef.current.value,
        to: toDateRef.current.value,
        status: status,
        active: active,
      });
      setSearchResShift(null);
      setSearchResUsers(null);
      setSearchResAction(response);
    }

    setSearchSubmitLoading(false);
  };

  const handleSearchReset = (e) => {
    e.preventDefault();
    toDateRef.current.reset();
    fromDateRef.current.reset();
    codeRef.current.reset();
    nameRef.current.reset();
    setStatus("");
    setActive("");
    setUserSch(null);
    setActionSch(null);
    setSearchFieldReset(true);
  };

  const handleDrawerClose = () => {
    setIsDrawerOpen(false);
  };

  const nextButtonHandler = () => {
    switch (drawerTab) {
      case 1: {
        const shiftErrors = shiftDetailsValidation(shiRef.current.getData());
        if (Object.keys(shiftErrors).length > 0) {
          dispatch(
            errorActions.addShiftDetailsErrorObject({
              form: "shiftDetailsErrors",
              errors: shiftErrors,
            }),
          );
          toast.error("please fill the required fields", {
            autoClose: 5000,
            containerId: "Main",
          });
          return;
        } else {
          dispatch(errorActions.clearShiftDetailsError());
        }
        break;
      }
      default:
    }
    // setDrawerTab(next());
  };

  const shiftReset = () => {
    shiRef.current.resetForm();
    // userRef.current.resetForm();

    setEditMode(false);
    setEditShift(null);
  };
  const userReset = () => {
    // shiRef.current.resetForm();
    userRef.current.resetForm();

    setEditMode(false);
    setEditShift(null);
  };
  const actionReset = () => {
    // shiRef.current.resetForm();
    actionRef.current.resetForm();

    setEditMode(false);
    setEditShift(null);
  };

  const handleShiftSubmit = async (e, bypassDeleteCheck = false) => {
    e.preventDefault();
    if (!bypassDeleteCheck && shiRef.current.isDeletedActive()) {
      setPendingSubmitEvent(e);
      setShowDeleteWarning(true);
      deleteWarningRef.current?.showModal();
      return;
    }
    setIsSubmitLoading(true);

    dispatch(errorActions.clearShiftDetailsError());
    console.log("shiRef.current.getData()", shiRef.current.getData());
    const shiftDetailsErrors = shiftDetailsValidation(shiRef.current.getData());

    if (Object.keys(shiftDetailsErrors).length > 0) {
      dispatch(
        errorActions.validateShiftDetails({
          shiftDetailsData: shiRef.current.getData(),
        }),
      );
      setIsSubmitLoading(false);
      toast.error("There was an error adding Shift", {
        autoClose: 5000,
        containerId: "Main",
      });
      return;
    } else {
      if (editMode) {
        try {
          const response = await updateShift({
            // shiftUserRequest: userRef.current.getData(),
            shiftRequest: shiRef.current.getData(),
            author: user.username,
          });

          if (response !== null) {
            toast.success("Shift updated successfully!", {
              autoClose: 5000,
              containerId: "Main",
            });
          }
          setIsSubmitLoading(false);
          shiftReset();
        } catch (e) {
          if (e.response.status === 409) {
            toast.error("Shift name already exists!", {
              autoClose: 5000,
              containerId: "Main",
            });
          }
          setIsSubmitLoading(false);
        }
      } else {
        try {
          const response = await addShift({
            // shiftUserRequest: userRef.current.getData(),
            shiftRequest: shiRef.current.getData(),
            author: user.username,
          });
          if (response !== null) {
            toast.success("Shift added successfully!", {
              autoClose: 5000,
              containerId: "Main",
            });
            // reset();
          }
          setIsSubmitLoading(false);
          shiftReset();
        } catch (e) {
          if (e.response.status === 409) {
            toast.error("Shift name already exists!", {
              autoClose: 5000,
              containerId: "Main",
            });
          }
          setIsSubmitLoading(false);
        }
      }
    }
    setIsSubmitLoading(false);
  };

  const handleUserSubmit = async (e) => {
    e.preventDefault();
    const shiftUserData = userRef.current.getData();
    if (shiftUserData.length <= 0) {
      dispatch(
        errorActions.addShiftDetailsErrorObject({
          form: "submitErrors",
          key: "approvalDetailsError",
          value: "Should have at least one Shift User",
        }),
      );
      toast.error("Should have at least one Shift User", {
        autoClose: 5000,
        containerId: "Main",
      });
      setIsSubmitLoading(false);
      return;
    } else {
      if (editMode) {
        try {
          const response = await updateShift({
            shiftUserRequest: userRef.current.getData(),
            // shiftRequest: shiRef.current.getData(),
            author: user.username,
          });

          if (response !== null) {
            toast.success("Shift updated successfully!", {
              autoClose: 5000,
              containerId: "Main",
            });
          }
          setIsSubmitLoading(false);
        } catch (e) {
          setIsSubmitLoading(false);
        }
      } else {
        try {
          const response = await addShift({
            shiftUserRequest: userRef.current.getData(),
            // shiftRequest: null,
            author: user.username,
          });
          if (response !== null) {
            toast.success("Shift added successfully!", {
              autoClose: 5000,
              containerId: "Main",
            });
            // reset();
          }
          setIsSubmitLoading(false);
        } catch (e) {
          setIsSubmitLoading(false);
        }
      }
      userReset();
    }
    setIsSubmitLoading(false);
  };

  const handleActionSubmit = async (e) => {
    e.preventDefault();
    const shiftactionData = actionRef.current.getData();
    if (shiftactionData.length <= 0) {
      dispatch(
        errorActions.addShiftDetailsErrorObject({
          form: "submitErrors",
          key: "approvalDetailsError",
          value: "Should have at least one Shift action",
        }),
      );
      toast.error("Should have at least one Shift Action", {
        autoClose: 5000,
        containerId: "Main",
      });
      setIsSubmitLoading(false);
      return;
    } else {
      if (editMode) {
        try {
          const response = await updateShift({
            // shiftUserRequest: userRef.current.getData(),
            // shiftRequest: shiRef.current.getData(),
            shiftActionRequest: actionRef.current.getData(),
            author: user.username,
          });

          if (response !== null) {
            toast.success("Shift Action updated successfully!", {
              autoClose: 5000,
              containerId: "Main",
            });
          }
          setIsSubmitLoading(false);
        } catch (e) {
          setIsSubmitLoading(false);
        }
      } else {
        try {
          const response = await addShift({
            // shiftUserRequest: userRef.current.getData(),
            // shiftRequest: null,
            shiftActionRequest: actionRef.current.getData(),
            author: user.username,
          });
          if (response !== null) {
            toast.success("Shift Action added successfully!", {
              autoClose: 5000,
              containerId: "Main",
            });
            // reset();
          }
          setIsSubmitLoading(false);
        } catch (e) {
          setIsSubmitLoading(false);
        }
      }
      actionReset();
    }
    setIsSubmitLoading(false);
  };

  const [activeAccordion1, setActiveAccordion1] = useState(true);
  const [resetVisible, setResetVisible] = useState(false);
  const [searchClicked, setSearchClicked] = useState(false);
  const [searchUserClicked, setSearchUserClicked] = useState(false);
  const [searchActionClicked, setSearchActionClicked] = useState(false);

  const deleteWarningModal = (
    <div style={{ padding: "20px" }}>
      <h3 style={{ display: "flex", alignItems: "center", gap: "5px" }}>
        <AlertCircle color="red" size="25" />
        <p>Warning</p>
      </h3>
      <p>Active is set to Deleted. Are you sure you want to proceed?</p>
      <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
        <Button
          label="Cancel"
          onClick={() => {
            deleteWarningRef.current?.close();
            setShowDeleteWarning(false);
            setPendingSubmitEvent(null);
          }}
        />
        <Button
          label="Proceed"
          className="ui red button"
          onClick={() => {
            deleteWarningRef.current?.close();
            setShowDeleteWarning(false);

            const submitFn =
              drawerTab === 1
                ? handleShiftSubmit
                : drawerTab === 2
                  ? handleUserSubmit
                  : drawerTab === 3
                    ? handleActionSubmit
                    : null;

            submitFn({ preventDefault: () => {} }, true);

            setPendingSubmitEvent(null);
          }}
        />
      </div>
    </div>
  );

  return (
    <>
      <div
        className="ui attached tabular"
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div className="ui tabular menu attached">
          <Tab
            Icon={Clock}
            onClick={() => {
              setTab(1);
              setDrawerTab(1);
            }}
            active={tab === 1}
            label="Shift Search"
            resizeForSmallerScreens={true}
          />
          <Tab
            Icon={User}
            onClick={() => {
              setDrawerTab(2);
              setTab(2);
            }}
            active={tab === 2}
            label="Shift Users Search"
            resizeForSmallerScreens={true}
          />
          <Tab
            Icon={User}
            onClick={() => {
              setDrawerTab(3);
              setTab(3);
            }}
            active={tab === 3}
            label="Shift Action Search"
            resizeForSmallerScreens={true}
          />
        </div>
        <Button
          template="drawerOpen"
          onClick={handleDrawerOpen}
          authenticated={true}
          form={FORMS.CALL_CENTER_SHIFT.SHI.form}
          module={MODULES.Master}
          editMode={false}
        />
      </div>
      <div
        className="ui bottom attached active tab segment"
        style={{ display: tab === 1 ? "block" : "none" }}
      >
        <div className="ui styled accordion" style={{ width: "100%" }}>
          <div
            className={`title ${activeAccordion1 ? "active" : ""}`}
            onClick={() => setActiveAccordion1(!activeAccordion1)}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>
                <span>Search</span>
                <Search size={14} style={{ marginLeft: "10px" }} />
                <i className="dropdown icon"></i>
              </div>

              <i
                className="refresh icon primary button"
                style={{
                  display: `${resetVisible ? "flex" : "none"}`,
                  cursor: "pointer",
                }}
                onClick={(e) => {
                  handleReset(e);
                }}
              ></i>
            </div>
          </div>
          <div className={`content ${activeAccordion1 ? "active" : ""}`}>
            {isSearchLoading ? (
              <LoadingSpinner />
            ) : (
              <form className="ui form">
                <div className="four fields">
                  <Input
                    label="Shift Code"
                    placeholder="Shift Code"
                    name="shiftCode"
                    ref={codeRef}
                  />
                  <Input
                    label="Shift Name"
                    placeholder="Shift Name"
                    name="shiftName"
                    ref={nameRef}
                  />
                  <Input
                    label="from Date"
                    type="date"
                    name="empExpiaryDate"
                    placeholder="To Date"
                    ref={fromDateRef}
                  />
                  <Input
                    label="To Date"
                    type="date"
                    name="empExpiaryDate"
                    placeholder="To Date"
                    ref={toDateRef}
                  />
                </div>
                <div className="four fields">
                  <Dropdown
                    label="Status"
                    options={statusOptions}
                    placeholder="Status"
                    style={{ height: "20px" }}
                    value={status}
                    onChange={(e, data) => {
                      setStatus(data.value);
                    }}
                  />
                  <Dropdown
                    label="Active"
                    options={activeOptions}
                    placeholder="Active"
                    style={{ height: "20px" }}
                    value={active}
                    onChange={(e, data) => {
                      setActive(data.value);
                    }}
                  />
                </div>

                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                  }}
                >
                  <div className="field" style={{ width: "100%" }}>
                    <Button
                      template="search"
                      onClick={(e) => {
                        handleSearchSubmit(e);
                      }}
                    />
                    <Button
                      template="searchReset"
                      onClick={(e) => {
                        handleSearchReset(e);
                      }}
                    />
                  </div>
                </div>
              </form>
            )}
          </div>
        </div>
        {searchClicked && (
          <>
            {searchSubmitLoading ? (
              <LoadingSpinner />
            ) : (
              <Grid
                isLoading={searchFetchLoading}
                content={searchResShift}
                cellSizeStrategy="fitCellContents"
                // fitContentCellls={["blkAccident"]}
                config={[
                  {
                    headerName: "Id",
                    field: "id",
                    sort: "desc",
                    hide: true,
                  },
                  {
                    headerName: "Code",
                    field: "code",
                  },
                  {
                    headerName: "Shift Name",
                    field: "name_",
                  },
                  {
                    headerName: "Status",
                    field: "status",
                    cellRenderer: StatusCellStyle,
                  },
                  {
                    headerName: "Active",
                    field: "active",
                    cellRenderer: ActiveCellStyle,
                  },
                ]}
                onCellDoubleClicked={async (props) => {
                  setSearchFetchLoading(true);
                  const response = await getShiftById(props.data.id);
                  setEditShift(response);
                  console.log("shif log res ", response);
                  dispatch(errorActions.clearShiftDetailsError());
                  setEditMode(true);
                  setIsDrawerOpen(true);
                  setSearchFetchLoading(false);
                  setDrawerTab(firstViableTab);
                }}
              />
            )}
          </>
        )}
      </div>
      <div
        className="ui bottom attached active tab segment"
        style={{ display: tab === 2 ? "block" : "none" }}
      >
        <div className="ui styled accordion" style={{ width: "100%" }}>
          <div
            className={`title ${activeAccordion1 ? "active" : ""}`}
            onClick={() => setActiveAccordion1(!activeAccordion1)}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>
                <span>Search</span>
                <Search size={14} style={{ marginLeft: "10px" }} />
                <i className="dropdown icon"></i>
              </div>

              <i
                className="refresh icon primary button"
                style={{
                  display: `${resetVisible ? "flex" : "none"}`,
                  cursor: "pointer",
                }}
                onClick={(e) => {
                  handleReset(e);
                }}
              ></i>
            </div>
          </div>
          <div className={`content ${activeAccordion1 ? "active" : ""}`}>
            {isSearchLoading ? (
              <LoadingSpinner />
            ) : (
              <form className="ui form">
                <h4 className="ui dividing header"></h4>

                <div className="four fields">
                  <Input
                    label="User Code"
                    placeholder="Shift Code"
                    name="shiftCode"
                    ref={codeRef}
                  />
                  <SearchDropdown
                    key={1}
                    // editMode={editMode}
                    // multiGrid={true}
                    // multiGridCurrentValue={shiftUserData.user}
                    reset={searchFieldReset}
                    setReset={setSearchFieldReset}
                    clearable={true}
                    api={getBehalfOf}
                    apiDependency={{
                      customer: null,
                      shipper: null,
                    }}
                    onResultSelect={(data) => setUserSch(data)}
                    onClear={() => {
                      setUserSch(null);
                    }}
                    label="User"
                    field="req_behalf_of"
                  />
                  <Input
                    label="from Date"
                    type="date"
                    name="empExpiaryDate"
                    placeholder="To Date"
                    ref={fromDateRef}
                  />
                  <Input
                    label="To Date"
                    type="date"
                    name="empExpiaryDate"
                    placeholder="To Date"
                    ref={toDateRef}
                  />
                </div>
                <div className="four fields">
                  <Dropdown
                    label="Status"
                    options={statusOptions}
                    placeholder="Status"
                    style={{ height: "20px" }}
                    value={status}
                    onChange={(e, data) => {
                      setStatus(data.value);
                    }}
                  />
                  <Dropdown
                    label="Active"
                    options={activeOptions}
                    placeholder="Active"
                    style={{ height: "20px" }}
                    value={active}
                    onChange={(e, data) => {
                      setActive(data.value);
                    }}
                  />
                </div>

                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                  }}
                >
                  <div className="field" style={{ width: "100%" }}>
                    <Button
                      template="search"
                      onClick={(e) => {
                        handleSearchSubmit(e);
                      }}
                    />
                    <Button
                      template="searchReset"
                      onClick={(e) => {
                        handleSearchReset(e);
                      }}
                    />
                  </div>
                </div>
              </form>
            )}
          </div>
        </div>
        {searchUserClicked && (
          <>
            {searchSubmitLoading ? (
              <LoadingSpinner />
            ) : (
              <Grid
                isLoading={searchFetchLoading}
                content={searchResUsers}
                cellSizeStrategy="fitCellContents"
                // fitContentCellls={["blkAccident"]}
                config={[
                  {
                    headerName: "Id",
                    field: "id",
                    sort: "desc",
                    hide: true,
                  },
                  {
                    headerName: "Code",
                    field: "code",
                  },
                  {
                    headerName: "User Name",
                    field: "name_",
                  },
                  {
                    headerName: "Status",
                    field: "status",
                    cellRenderer: StatusCellStyle,
                  },
                  {
                    headerName: "Active",
                    field: "active",
                    cellRenderer: ActiveCellStyle,
                  },
                ]}
                onCellDoubleClicked={async (props) => {
                  setSearchFetchLoading(true);
                  const response = await getShiftUserById(props.data.id);
                  setEditShiftUser(response);
                  console.log("user log res ", response);
                  setEditMode(true);
                  setIsDrawerOpen(true);
                  setSearchFetchLoading(false);
                  setDrawerTab(2);
                }}
              />
            )}
          </>
        )}
      </div>
      <div
        className="ui bottom attached active tab segment"
        style={{ display: tab === 3 ? "block" : "none" }}
      >
        <div className="ui styled accordion" style={{ width: "100%" }}>
          <div
            className={`title ${activeAccordion1 ? "active" : ""}`}
            onClick={() => setActiveAccordion1(!activeAccordion1)}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div>
                <span>Search</span>
                <Search size={14} style={{ marginLeft: "10px" }} />
                <i className="dropdown icon"></i>
              </div>

              <i
                className="refresh icon primary button"
                style={{
                  display: `${resetVisible ? "flex" : "none"}`,
                  cursor: "pointer",
                }}
                onClick={(e) => {
                  handleReset(e);
                }}
              ></i>
            </div>
          </div>
          <div className={`content ${activeAccordion1 ? "active" : ""}`}>
            {isSearchLoading ? (
              <LoadingSpinner />
            ) : (
              <form className="ui form">
                <h4 className="ui dividing header"></h4>

                <div className="four fields">
                  <Input
                    label="Shift Code"
                    placeholder="Shift Code"
                    name="shiftCode"
                    ref={codeRef}
                  />
                  <Dropdown
                    clearable
                    search={true}
                    options={actionStatusOptions}
                    placeholder="Master Status"
                    label="Master Status"
                    value={actionSch}
                    onChange={(e, data) => {
                      setActionSch(data.value);
                      console.log("data", data);
                    }}
                  />
                  <Input
                    label="from Date"
                    type="date"
                    name="empExpiaryDate"
                    placeholder="To Date"
                    ref={fromDateRef}
                  />
                  <Input
                    label="To Date"
                    type="date"
                    name="empExpiaryDate"
                    placeholder="To Date"
                    ref={toDateRef}
                  />
                </div>
                <div className="four fields">
                  <Dropdown
                    label="Status"
                    options={statusOptions}
                    placeholder="Status"
                    style={{ height: "20px" }}
                    value={status}
                    onChange={(e, data) => {
                      setStatus(data.value);
                    }}
                  />
                  <Dropdown
                    label="Active"
                    options={activeOptions}
                    placeholder="Active"
                    style={{ height: "20px" }}
                    value={active}
                    onChange={(e, data) => {
                      setActive(data.value);
                    }}
                  />
                </div>

                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                  }}
                >
                  <div className="field" style={{ width: "100%" }}>
                    <Button
                      template="search"
                      onClick={(e) => {
                        handleSearchSubmit(e);
                      }}
                    />
                    <Button
                      template="searchReset"
                      onClick={(e) => {
                        handleSearchReset(e);
                      }}
                    />
                  </div>
                </div>
              </form>
            )}
          </div>
        </div>
        {searchActionClicked && (
          <>
            {searchSubmitLoading ? (
              <LoadingSpinner />
            ) : (
              <Grid
                isLoading={searchFetchLoading}
                content={searchResAction}
                cellSizeStrategy="fitCellContents"
                // fitContentCellls={["blkAccident"]}
                config={[
                  {
                    headerName: "Id",
                    field: "id",
                    sort: "desc",
                    hide: true,
                  },
                  {
                    headerName: "Code",
                    field: "code",
                  },
                  {
                    headerName: "Shift Name",
                    field: "name_",
                  },
                  {
                    headerName: "Status",
                    field: "status",
                    cellRenderer: StatusCellStyle,
                  },
                  {
                    headerName: "Active",
                    field: "active",
                    cellRenderer: ActiveCellStyle,
                  },
                ]}
                onCellDoubleClicked={async (props) => {
                  setSearchFetchLoading(true);
                  const response = await getShiftActionById(props.data.id);
                  setEditShiftAction(response);
                  console.log("shif log res ", response);
                  setEditMode(true);
                  setIsDrawerOpen(true);
                  setSearchFetchLoading(false);
                  setDrawerTab(3);
                }}
              />
            )}
          </>
        )}
      </div>

      {/* Side Drawer */}
      <SideDrawer
        open={isDrawerOpen}
        handleDrawerClose={handleDrawerClose}
        head={
          tab === 1 ? (
            editMode ? (
              <div
                className="shift-code-header"
                style={{ padding: "10px 16px", borderBottom: "1px solid #ccc" }}
              >
                <h3>Shift Code: {editShift?.shiftResponse?.shiCode}</h3>
              </div>
            ) : null
          ) : tab === 2 ? (
            editMode ? (
              <div
                className="shift-code-header"
                style={{ padding: "10px 16px", borderBottom: "1px solid #ccc" }}
              >
                <h3>
                  Shift User Code:{" "}
                  {editShiftUser?.shiftUserResponses[0]?.shuCode}
                </h3>
              </div>
            ) : null
          ) : tab === 3 ? (
            editMode ? (
              <div
                className="shift-code-header"
                style={{ padding: "10px 16px", borderBottom: "1px solid #ccc" }}
              >
                <h3>
                  Shift Action Code:{" "}
                  {editShiftAction?.shiftActionResponses?.shaCode}
                </h3>
              </div>
            ) : null
          ) : null
        }
        body={
          <>
            <form
              className="drawer-content"
              onSubmit={
                drawerTab === 1
                  ? handleShiftSubmit
                  : drawerTab === 2
                    ? handleUserSubmit
                    : drawerTab === 3
                      ? handleActionSubmit
                      : null
              }
            >
              <div className={"shift-card-container"}>
                <div style={{ width: "60vw", boxShadow: "none" }}>
                  <div className="ui top attached tabular menu">
                    {tab === 1 ? (
                      <Tab
                        Icon={Clock}
                        onClick={() => {
                          setDrawerTab(1);
                        }}
                        active={drawerTab === 1}
                        errors={
                          Object.keys(errorState.shiftDetailsErrors).length !==
                          0
                        }
                        label="Shift"
                        authenticated={true}
                        form={FORMS.CALL_CENTER_SHIFT.SHIFT.form}
                        showMandatory={true}
                        isMandatory={true}
                      />
                    ) : tab === 2 ? (
                      <Tab
                        Icon={User}
                        onClick={() => {
                          setDrawerTab(2);
                        }}
                        active={drawerTab === 2}
                        label="Users"
                        authenticated={true}
                        form={FORMS.CALL_CENTER_SHIFT.SHIFT_USER.form}
                      />
                    ) : tab === 3 ? (
                      <Tab
                        Icon={User}
                        onClick={() => {
                          setDrawerTab(3);
                        }}
                        active={drawerTab === 3}
                        label="Action"
                        authenticated={true}
                        form={FORMS.CALL_CENTER_SHIFT.SHIFT_ACTION.form}
                      />
                    ) : null}
                  </div>
                  {tab === 1 ? (
                    <>
                      <div
                        className="ui bottom attached active tab segment"
                        style={{ display: drawerTab === 1 ? "block" : "none" }}
                      >
                        <ShiftMasterForm
                          editMode={editMode}
                          errors={errorState.shiftDetailsErrors}
                          isLoading={isLoading}
                          currentValues={
                            editShift ? editShift.shiftResponse : null
                          }
                          ref={shiRef}
                        />
                      </div>
                    </>
                  ) : tab === 2 ? (
                    <>
                      <div
                        className="ui bottom attached active tab segment"
                        style={{ display: drawerTab === 2 ? "block" : "none" }}
                      >
                        <ShiftUsersForm
                          editMode={editMode}
                          isLoading={isLoading}
                          currentValues={
                            editShiftUser
                              ? editShiftUser.shiftUserResponses
                              : null
                          }
                          ref={userRef}
                        />
                      </div>
                    </>
                  ) : tab === 3 ? (
                    <>
                      <div
                        className="ui bottom attached active tab segment"
                        style={{ display: drawerTab === 3 ? "block" : "none" }}
                      >
                        <ShiftActionForm
                          editMode={editMode}
                          isLoading={isLoading}
                          currentValues={
                            editShiftAction
                              ? editShiftAction.shiftActionResponses
                              : null
                          }
                          ref={actionRef}
                        />
                      </div>
                    </>
                  ) : null}

                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-end",
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      {/*{drawerTab > firstViableTab && (*/}
                      {/*    <Button*/}
                      {/*        template="back"*/}
                      {/*        tab={drawerTab - 1}*/}
                      {/*        module={MODULES.Master}*/}
                      {/*        section={FORMS.CALL_CENTER_SHIFT}*/}
                      {/*        authenticated={true}*/}
                      {/*        onClick={() => setDrawerTab(prev())}*/}
                      {/*    />*/}
                      {/*)}*/}
                      {/*{drawerTab < lastViableTab && (*/}
                      {/*    <Button*/}
                      {/*        template="next"*/}
                      {/*        tab={drawerTab + 1}*/}
                      {/*        module={MODULES.Master}*/}
                      {/*        section={FORMS.CALL_CENTER_SHIFT}*/}
                      {/*        authenticated={true}*/}
                      {/*        onClick={nextButtonHandler}*/}
                      {/*    />*/}
                      {/*)}*/}
                      {editMode ? (
                        <Button
                          type="submit"
                          template="create"
                          isLoading={isSubmitLoading}
                          create={!editMode}
                          form={FORMS.CALL_CENTER_SHIFT.SHI.form}
                          module={MODULES.Master}
                          section={FORMS.CALL_CENTER_SHIFT}
                          authenticated={true}
                          editMode={editMode}
                        />
                      ) : drawerTab === 1 ||
                        drawerTab === 2 ||
                        (drawerTab === 3 && !isLoading) ? (
                        <Button
                          type="submit"
                          template="create"
                          isLoading={isSubmitLoading}
                          create={!editMode}
                          form={FORMS.CALL_CENTER_SHIFT.SHI.form}
                          module={MODULES.Master}
                          section={FORMS.CALL_CENTER_SHIFT}
                          authenticated={true}
                          editMode={editMode}
                        />
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  {submitted && errorState.hasErrors && (
                    <UIMessage type="negative" width="100%" centered={false}>
                      <div className="content">
                        <div className="header">
                          There was some errors with your submission
                        </div>
                        {Object.keys(errorState.shiftDetailsErrors).length >
                          0 && (
                          <p>
                            <div className="header">Employee</div>
                            <div className="content">
                              <ul>
                                {Object.entries(
                                  errorState.shiftDetailsErrors,
                                ).map(([_, value]) => (
                                  <li>{value}</li>
                                ))}
                              </ul>
                            </div>
                          </p>
                        )}
                      </div>
                    </UIMessage>
                  )}
                </div>
              </div>
            </form>
            <Modal
              ref={deleteWarningRef}
              closeButton={false}
              minWidth={"300px"}
            >
              {showDeleteWarning && deleteWarningModal}
            </Modal>
          </>
        }
        style={{ width: "60vw", boxShadow: "none" }}
      />
    </>
  );
};
export default ShiftMaster;
